import React,{ useState} from 'react';
import '../../Styles/SideMenuBar.css';
import '../../Styles/Colors.css';      
import {NavLink, useLocation, useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import Badge from '@mui/material/Badge';
import omfLogo from '../../assets/svg/logo.svg';
import omfLogoText from '../../assets/svg/logoText.svg';
import CreatePost from '../../Views/User/CreatePostUi/CreatePost';

import { useCart } from '../../CartProvider';
import authMiddleware from '../authMiddleware';
import UserHome from '../../assets/svg/userHomeIcon';
import UserReels from '../../assets/svg/userReelsIcon';
import UserPostIcon from '../../assets/svg/userPostIconWeb';
import UserOrderIcon from '../../assets/svg/userOrderIcon';
import UserCart from '../../assets/svg/userCart';
import UserPostIconMobile from '../../assets/svg/userPostIconMobile';
import { useMute } from '../../MuteContext';
import EventsIcon from '../../assets/svg/eventsIcon.jsx';
import { useCallback } from 'react';

function SideMenuBar({getPosts=()=>{}}) {

    const { cartCount } = useCart();
    
    const [openInitialPopup, setOpenInitialPopup] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const [showMore, setShowMore] = useState(false);
    const { setIsMuted } = useMute();
    const handleOpenPost = () => {
        if (!authMiddleware()) {  
            return;
        }
        setIsMuted(true);
        setOpenInitialPopup(true);
    };    
    const {t} = useTranslation();

    const handleNavigate = () =>{
        navigate('/dashboard');
    };
    
    const handleNavigationOrders = (e) => {
        e.preventDefault(); 
        if (authMiddleware()) {
            navigate('/orders');
        } else {
            return;
        }
    };
    
    const handleNavigationCarts = (e) => {
        e.preventDefault();
        if (authMiddleware()) {
            navigate('/cart');
        } else {
            return;
        }
    };


    const handleNavigationMyTickets = useCallback((e) => {
        e?.preventDefault?.();
        navigate('/my-tickets');
    }, [navigate]);


    return (
        <>
            <div className="menu-container">
                <div className='sidebar-scrollable'>
                    <div>
                        <div className="omf-container" onClick={() => handleNavigate()}>
                            <img src={omfLogo} alt="logo" className='omf-svg-logo'/>
                            <img src={omfLogoText} alt="logo-text" className='omf-svg-title'/>
                        </div>

                        <ul className="menu-items">

                            <li>
                                <NavLink  className="list-container" to='/Dashboard' >
                                    <UserHome/>
                                    <h3 className="list-text">{t('sidemenubar.home')}</h3>
                                    <p className='icon-underline'></p>
                                </NavLink>
                            </li>

                            <li>
                                <NavLink className="list-container" to='/reels' >
                                    <UserReels/>
                                    <h3 className="list-text" 
                                    >
                                        {t('sidemenubar.reels')}
                                    </h3>
                                    <p className='icon-underline'></p>
            
                                </NavLink>
                            </li>

                            <li className="list-container" onClick={()=>handleOpenPost()}>
                                <UserPostIcon/>
                                <UserPostIconMobile/>
                                <h3 className="list-text post">{t('sidemenubar.post')}</h3>
                            </li>

                            {
                                openInitialPopup && (
                                    <CreatePost
                                        openInitialPopup={openInitialPopup}
                                        setOpenInitialPopup={setOpenInitialPopup}
                                        selectedFiles={selectedFiles}
                                        setSelectedFiles={setSelectedFiles}
                                        getPosts={getPosts}
                                        handleCloseModal={() => setOpenInitialPopup(false)}   
                                    />
                                )
                            }

                            <li>
                                <NavLink className="list-container" to='/events'>
                                    <EventsIcon className="stroke-red" width={30} height={40} color="#ffffff" />
                                    <h3 className="list-text">Events</h3>
                                    <p className='icon-underline'></p>
                                </NavLink>
                            </li>
                            {/* Burger (More) for mobile */}
                            <li className="list-container mobile-only-burger" onClick={()=>setShowMore((v)=>!v)}>
                                {/* Standard hamburger icon */}
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" className='burger-svg-icon stroke-red' fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="3" y1="6" x2="21" y2="6" />
                                    <line x1="3" y1="12" x2="21" y2="12" />
                                    <line x1="3" y1="18" x2="21" y2="18" />
                                </svg>
                                <h3 className="list-text">More</h3>
                            </li>
                          

                          
                        </ul>
                    </div>
                    {/* Removed tagline to prevent pushing menu down on larger screens */}
                </div>
                {showMore && (
                    <div className="mobile-more-menu" onClick={()=>setShowMore(false)}>
                        <div className="mobile-more-sheet" onClick={(e)=>e.stopPropagation()}>
                            <ul className="mobile-more-list">
                                <li>
                                    <div 
                                        className={`list-container ${location.pathname === '/orders' ? 'active' : ''}`}
                                        onClick={handleNavigationOrders} >
                                        <UserOrderIcon/>
                                        <h3 className="list-text">Orders</h3>
                                        
                                    </div>
                                </li> 

                                <li>
                                    <div  
                                        className={`list-container ${location.pathname === '/cart' ? 'active' : ''}`}
                                        onClick={handleNavigationCarts}>
                                        <Badge badgeContent={cartCount} color="primary" >
                                            <UserCart/>
                                        </Badge>
                                        <h3 className="list-text">{t('sidemenubar.cart')}</h3>
                                        
                                    </div>
                                </li>
                                <li>
                                    <div 
                                        className={`list-container ${location.pathname === '/my-tickets' ? 'active' : ''}`}
                                        onClick={handleNavigationMyTickets}>
                                        <EventsIcon className="stroke-red" width={30} height={40} color="#ffffff" />
                                        <h3 className="list-text">My Tickets</h3>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default SideMenuBar;
